import { LocationType, type MapPoint } from '../types';

export const MIN_ZOOM = 0.1;
export const METRO_ZOOM = 2.5;
export const CITY_ZOOM = 6;
export const MAX_ZOOM = 10;
export const METRO_CITY_FOCUS_ZOOM = 8;

const ZOOM_STOP_THRESHOLD = 0.01; // this is to stop right before the next layer (without data)

export const MIN_RADIUS = 4;
export const MAX_RADIUS = 40;

export const getMaxZoom = (effectivePoints: MapPoint[] | undefined) => {
  if (!effectivePoints || effectivePoints?.length === 0) {
    return MAX_ZOOM - ZOOM_STOP_THRESHOLD;
  }

  if (
    effectivePoints?.some(
      (point) =>
        point.locationType === LocationType.CITY ||
        point.locationType === LocationType.COUNTY
    )
  ) {
    return MAX_ZOOM - ZOOM_STOP_THRESHOLD;
  }

  if (
    effectivePoints?.some(
      (point) => point.locationType === LocationType.METRO_AREA
    )
  ) {
    return CITY_ZOOM - ZOOM_STOP_THRESHOLD;
  }

  if (
    effectivePoints?.some((point) => point.locationType === LocationType.STATE)
  ) {
    return CITY_ZOOM - ZOOM_STOP_THRESHOLD;
  }

  return METRO_ZOOM - ZOOM_STOP_THRESHOLD;
};
